import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { FinanceProvider } from './contexts/FinanceContext';
import ProtectedRoute from './components/ProtectedRoute';
import Welcome from './components/Welcome';
import Login from './components/Login';
import Home from './components/Home';
import Students from './components/Students';
import ActionBoard from './components/ActionBoard';
import Deals from './components/Deals';
import MyAnalytics from './components/MyAnalytics';
import Settings from './components/Settings';
import Agents from './components/Agents';
import Alumni from './components/Alumni';
import CountryGuide from './components/CountryGuide';
import StudentAppAdmin from './components/StudentAppAdmin';
import Meetings from './components/Meetings';
import TeamTasks from './components/TeamTasks';
import TeamFoundation from './components/TeamFoundation';
import Complaints from './components/FoundationStep3';
import SupportInbox from './components/SupportInbox';
import AppLeads from './components/AppLeads';
import Feedback from './components/Feedback';
import VisaCases from './components/VisaCases';
import Settling from './components/Settling';
import AppFunnel from './components/AppFunnel';
import AppLogins from './components/AppLogins';
import DeletedStudents from './components/DeletedStudents';
import AuditLog from './components/AuditLog';
import DataRequests from './components/DataRequests';
import Agencies from './components/Agencies';
import PartnerAnalytics from './components/PartnerAnalytics';
import SubAgentApplications from './components/SubAgentApplications';
import GrowthAccess from './components/GrowthAccess';
import Partnerships from './components/Partnerships';
import Commissions from './components/Commissions';
import MarketingConfig from './components/MarketingConfig';
import MarketingPlan from './components/MarketingPlan';
import MyDuties from './components/MyDuties';
import UserManagement from './components/UserManagement';
import ServiceOrders from './components/ServiceOrders';
import Billing from './components/Billing';
import PaymentsDesk from './components/PaymentsDesk';
import MedicalTourism from './components/MedicalTourism';
import JobClients from './components/JobClients';
import JobOperations from './components/JobOperations';
import LanguageLessons from './components/LanguageLessons';
import TouristClients from './components/TouristClients';
import LearnerClients from './components/LearnerClients';
import FinanceMFAGate from './components/finance/FinanceMFAGate';
import FinanceDashboard from './components/finance/FinanceDashboard';
import ChartOfAccounts from './components/finance/ChartOfAccounts';
import FiscalPeriods from './components/finance/FiscalPeriods';
import JournalEntries from './components/finance/JournalEntries';
import Expenses from './components/finance/Expenses';
import FinancialReports from './components/finance/FinancialReports';
import SalesInvoices from './components/finance/SalesInvoices';
import IntercompanyTransactions from './components/finance/IntercompanyTransactions';
import AuditorExports from './components/finance/AuditorExports';
import TaxDeadlines from './components/finance/TaxDeadlines';
import AnomalyFlags from './components/finance/AnomalyFlags';
import PaymentProviderConfig from './components/finance/PaymentProviderConfig';
import ExcelMigrations from './components/finance/ExcelMigrations';
import FXRates from './components/finance/FXRates';
import AccessGrants from './components/finance/AccessGrants';
import BankAccounts from './components/finance/BankAccounts';
import PeriodReopenRequests from './components/finance/PeriodReopenRequests';
import BankStatementLines from './components/finance/BankStatementLines';
import ZimbabweTax from './components/finance/ZimbabweTax';
import RecurringTemplates from './components/finance/RecurringTemplates';
import FinanceAuditLog from './components/finance/FinanceAuditLog';
import QuickEntry from './components/finance/QuickEntry';
import TransferCash from './components/finance/TransferCash';
import CFOMetricsDashboard from './components/finance/CFOMetricsDashboard';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <FinanceProvider>
        <Router>
        <Routes>
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={<Navigate to="/welcome" replace />}
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute homeOnly>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/students"
            element={
              <ProtectedRoute>
                <Students />
              </ProtectedRoute>
            }
          />
          <Route
            path="/deals"
            element={
              <ProtectedRoute>
                <Deals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/action-board"
            element={
              <ProtectedRoute adminOrEmployeeOnly coreTeamOnly>
                <ActionBoard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/meetings"
            element={
              <ProtectedRoute coreTeamOnly>
                <Meetings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team-rules"
            element={
              <ProtectedRoute>
                <TeamFoundation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/complaints"
            element={
              <ProtectedRoute internalStaffOnly>
                <Complaints />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team-tasks"
            element={
              <ProtectedRoute coreTeamOnly>
                <TeamTasks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agents"
            element={
              <ProtectedRoute adminOnly salesOnly>
                <Agents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-analytics"
            element={
              <ProtectedRoute myAnalyticsOnly>
                <MyAnalytics />
              </ProtectedRoute>
            }
          />
          {/* The Monthly Board Report is retired: its figures live in My Analytics (per-role analytics Q4). */}
          <Route path="/analytics" element={<Navigate to="/my-analytics" replace />} />
          <Route
            path="/marketing"
            element={
              <ProtectedRoute marketingViewOnly>
                <MarketingPlan />
              </ProtectedRoute>
            }
          />
          {/* TikTok's sign-in sends the CMO / Chairman back here (marketing/tiktok.py). */}
          <Route
            path="/marketing/tiktok/callback"
            element={
              <ProtectedRoute marketingViewOnly>
                <MarketingPlan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-duties"
            element={
              <ProtectedRoute dutiesOnly>
                <MyDuties />
              </ProtectedRoute>
            }
          />
          <Route
            path="/marketing-config"
            element={
              <ProtectedRoute marketingOnly>
                <MarketingConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-management"
            element={
              <ProtectedRoute chairmanOnly>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/alumni"
            element={
              <ProtectedRoute internalStaffOnly>
                <Alumni />
              </ProtectedRoute>
            }
          />
          <Route
            path="/country-guide"
            element={
              <ProtectedRoute internalStaffOnly>
                <CountryGuide />
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-app-admin"
            element={
              <ProtectedRoute mobileAdminOnly>
                <StudentAppAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/support-inbox"
            element={
              <ProtectedRoute internalStaffOnly>
                <SupportInbox />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app-leads"
            element={
              <ProtectedRoute coreTeamOnly>
                <AppLeads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/feedback"
            element={
              <ProtectedRoute internalStaffOnly>
                <Feedback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visa-cases"
            element={
              <ProtectedRoute internalStaffOnly>
                <VisaCases />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settling"
            element={
              <ProtectedRoute internalStaffOnly>
                <Settling />
              </ProtectedRoute>
            }
          />
          <Route
            path="/website-leads"
            element={
              <ProtectedRoute coreTeamOnly>
                <AppLeads source="WEBSITE" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app-funnel"
            element={
              <ProtectedRoute internalStaffOnly>
                <AppFunnel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app-logins"
            element={
              <ProtectedRoute internalStaffOnly>
                <AppLogins />
              </ProtectedRoute>
            }
          />
          <Route
            path="/deleted-students"
            element={
              <ProtectedRoute internalStaffOnly>
                <DeletedStudents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit-log"
            element={
              <ProtectedRoute adminOnly>
                <AuditLog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/data-requests"
            element={
              <ProtectedRoute internalStaffOnly>
                <DataRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agencies"
            element={
              <ProtectedRoute growthStackOnly salesOnly>
                <Agencies />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sub-agent-applications"
            element={
              <ProtectedRoute growthStackOnly>
                <SubAgentApplications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partner-analytics"
            element={
              <ProtectedRoute growthStackOnly salesOnly>
                <PartnerAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/growth-access"
            element={
              <ProtectedRoute adminOnly>
                <GrowthAccess />
              </ProtectedRoute>
            }
          />
          <Route
            path="/partnerships"
            element={
              <ProtectedRoute adminOnly>
                <Partnerships />
              </ProtectedRoute>
            }
          />
          <Route
            path="/commissions"
            element={
              <ProtectedRoute adminOnly salesOnly>
                <Commissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-orders"
            element={
              <ProtectedRoute adminOrEmployeeOnly>
                <ServiceOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/billing"
            element={
              <ProtectedRoute internalStaffOnly paymentsOnly>
                <Billing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments-desk"
            element={
              <ProtectedRoute paymentsOnly>
                <PaymentsDesk />
              </ProtectedRoute>
            }
          />
          <Route
            path="/medical-tourism"
            element={
              <ProtectedRoute>
                <MedicalTourism />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-clients"
            element={
              <ProtectedRoute>
                <JobClients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/language-lessons"
            element={
              <ProtectedRoute>
                <LanguageLessons />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-operations"
            element={
              <ProtectedRoute>
                <JobOperations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learners"
            element={
              <ProtectedRoute>
                <LearnerClients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tourist-clients"
            element={
              <ProtectedRoute>
                <TouristClients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><FinanceDashboard /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/quick-entry"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><QuickEntry /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/transfer-cash"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><TransferCash /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/cfo-dashboard"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><CFOMetricsDashboard /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/accounts"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><ChartOfAccounts /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/periods"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><FiscalPeriods /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/entries"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><JournalEntries /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/expenses"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><Expenses /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/reports"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><FinancialReports /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/sales-invoices"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><SalesInvoices /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/intercompany"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><IntercompanyTransactions /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/auditor-exports"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><AuditorExports /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/tax-deadlines"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><TaxDeadlines /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/anomaly-flags"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><AnomalyFlags /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/payment-providers"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><PaymentProviderConfig /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/excel-migrations"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><ExcelMigrations /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/fx-rates"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><FXRates /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/access-grants"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><AccessGrants /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/bank-accounts"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><BankAccounts /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/period-reopen-requests"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><PeriodReopenRequests /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/bank-statement-lines"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><BankStatementLines /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/zimbabwe-tax"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><ZimbabweTax /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/recurring-templates"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><RecurringTemplates /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance/audit-log"
            element={
              <ProtectedRoute financeOnly>
                <FinanceMFAGate><FinanceAuditLog /></FinanceMFAGate>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/welcome" replace />} />
        </Routes>

      </Router>
      </FinanceProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
